import { ServicePageTemplate } from "@/components/services/ServicePageTemplate";
import { servicePages } from "@/data/servicePages";

const data = servicePages.find((s) => s.slug === "uif-monthly-declarations")!;
const UifMonthlyDeclarations = () => <ServicePageTemplate data={data} />;
export default UifMonthlyDeclarations;
